// project imports
import { MenuItem } from 'types/menu';

// assets
import {
  AppstoreOutlined,
  GiftOutlined,
  OrderedListOutlined,
  ShopOutlined,
  ShoppingOutlined,
  StarOutlined,
  TagsOutlined,
  ThunderboltOutlined
} from '@ant-design/icons';
import { PERMISSIONS } from 'constants/permissions';

// icons
const icons = {
  ShopOutlined,
  AppstoreOutlined,
  TagsOutlined,
  ShoppingOutlined,
  OrderedListOutlined,
  GiftOutlined,
  ThunderboltOutlined,
  StarOutlined
};

// ==============================|| MENU ITEMS - STORE MANAGEMENT ||============================== //

const storeManagement: MenuItem = {
  id: 'group-store-management',
  title: 'menu.storeManagement',
  type: 'group',
  children: [
    {
      id: 'products',
      title: 'menu.products',
      type: 'item',
      url: '/products',
      icon: icons.ShoppingOutlined,
      breadcrumbs: true,
      permission: PERMISSIONS.PRODUCTS_VIEW
    },
    {
      id: 'categories',
      title: 'menu.categories',
      type: 'item',
      url: '/categories',
      icon: icons.AppstoreOutlined,
      breadcrumbs: true,
      permission: PERMISSIONS.CATEGORIES_VIEW
    },
    {
      id: 'attributes',
      title: 'menu.attributes',
      type: 'item',
      url: '/attributes',
      icon: icons.TagsOutlined,
      breadcrumbs: true,
      permission: PERMISSIONS.ATTRIBUTES_VIEW
    },
    {
      id: 'orders',
      title: 'menu.orders',
      type: 'item',
      url: '/orders',
      icon: icons.OrderedListOutlined,
      breadcrumbs: true,
      permission: PERMISSIONS.ORDERS_VIEW
    },
    {
      id: 'coupons',
      title: 'menu.coupons',
      type: 'item',
      url: '/coupons',
      icon: icons.GiftOutlined,
      breadcrumbs: true,
      permission: PERMISSIONS.COUPONS_VIEW
    },
    {
      id: 'special-sales',
      title: 'menu.specialSales',
      type: 'item',
      url: '/special-sales',
      icon: icons.ThunderboltOutlined,
      breadcrumbs: true,
      permission: PERMISSIONS.SPECIAL_SALES_VIEW
    },
    {
      id: 'reviews',
      title: 'menu.reviews',
      type: 'item',
      url: '/reviews',
      icon: icons.StarOutlined,
      breadcrumbs: true,
      permission: PERMISSIONS.REVIEWS_VIEW
    }
  ]
};

export default storeManagement;
